<form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col p-6 sm:p-8 min-w-80 sm:min-w-96 max-h-[90vh] overflow-y-auto">
    <div class="flex items-start justify-between mb-4">
        <h2 class="text-xl font-bold">
            {{ 'features.establishment-switcher.add-dialog.title' | transloco }}
        </h2>
        <button mat-icon-button type="button" (click)="cancel()" class="-mr-2 -mt-2">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Identity block: name + slug + type + capacity -->
    <div class="flex flex-col gap-4">
        <mat-form-field class="w-full">
            <mat-label>
                {{ 'features.establishment-switcher.add-dialog.name-label' | transloco }}
            </mat-label>
            <input matInput formControlName="name" autocomplete="off" required />
            <mat-error *ngIf="form.get('name')?.hasError('required')">
                {{ 'features.establishment-switcher.add-dialog.name-required' | transloco }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>
                {{ 'features.establishment-switcher.add-dialog.slug-label' | transloco }}
            </mat-label>
            <input matInput formControlName="slug" autocomplete="off" required [errorStateMatcher]="immediateErrorMatcher" />
            <mat-spinner *ngIf="isSlugChecking" matSuffix diameter="18" class="mr-2"></mat-spinner>
            <mat-hint *ngIf="form.get('slug')?.value">
                <span class="text-xs text-secondary">
                    {{ 'features.establishment-switcher.add-dialog.slug-preview-label' | transloco }}
                </span>
                <span class="text-xs text-primary">{{ fullSlugUrl }}</span>
            </mat-hint>
            <mat-error *ngIf="form.get('slug')?.hasError('required')">
                {{ 'features.establishment-switcher.add-dialog.slug-required' | transloco }}
            </mat-error>
            <mat-error *ngIf="form.get('slug')?.hasError('pattern') || form.get('slug')?.hasError('minlength') || form.get('slug')?.hasError('maxlength')">
                {{ 'features.establishment-switcher.add-dialog.slug-pattern' | transloco }}
            </mat-error>
            <mat-error *ngIf="form.get('slug')?.hasError('slugTaken')">
                {{ 'features.establishment-switcher.add-dialog.slug-taken' | transloco }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>
                {{ 'features.establishment-switcher.add-dialog.type-label' | transloco }}
            </mat-label>
            <mat-select formControlName="establishmentTypeCode" required>
                <mat-option *ngFor="let type of data?.establishmentTypeList" [value]="type.code">
                    {{ 'refs.establishmentType.' + type.code | transloco }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('establishmentTypeCode')?.hasError('required')">
                {{ 'features.establishment-switcher.add-dialog.type-required' | transloco }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>
                {{ 'features.establishment-switcher.add-dialog.capacity-label' | transloco }}
            </mat-label>
            <mat-select formControlName="capacityCode" required>
                <mat-option *ngFor="let cap of data?.capacityRefList" [value]="cap.code">
                    {{ 'refs.capacity.' + cap.code | transloco }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('capacityCode')?.hasError('required')">
                {{ 'features.establishment-switcher.add-dialog.capacity-required' | transloco }}
            </mat-error>
        </mat-form-field>
    </div>

    <hr class="w-full border-t border-gray-200 my-4">

    <!-- Languages block -->
    <div class="flex flex-col">
        <mat-form-field class="w-full">
            <mat-label>
                {{ 'features.establishment-switcher.add-dialog.languages-label' | transloco }}
            </mat-label>
            <mat-select formControlName="languageCodes" multiple required>
                <mat-optgroup [label]="'features.establishment-switcher.add-dialog.languages-group-popular' | transloco">
                    <mat-option
                        *ngFor="let lang of priorityLanguages()"
                        [value]="lang.code"
                        [disabled]="isOptionDisabled(lang.code)"
                    >
                        {{ 'refs.menuLanguages.' + lang.code | transloco }}
                    </mat-option>
                </mat-optgroup>
                <mat-optgroup [label]="'features.establishment-switcher.add-dialog.languages-group-other' | transloco">
                    <mat-option
                        *ngFor="let lang of otherLanguages()"
                        [value]="lang.code"
                        [disabled]="isOptionDisabled(lang.code)"
                    >
                        {{ 'refs.menuLanguages.' + lang.code | transloco }}
                    </mat-option>
                </mat-optgroup>
            </mat-select>
            <mat-error *ngIf="form.get('languageCodes')?.hasError('required')">
                {{ 'features.establishment-switcher.add-dialog.languages-required' | transloco }}
            </mat-error>
            <mat-hint *ngIf="hasReachedLimit">
                {{ 'features.establishment-switcher.add-dialog.languages-limit-reached' | transloco }}
            </mat-hint>
        </mat-form-field>
    </div>

    <div class="flex justify-end gap-3 mt-6">
        <button mat-stroked-button type="button" (click)="cancel()">
            {{ 'features.establishment-switcher.add-dialog.cancel' | transloco }}
        </button>
        <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="form.invalid || form.pending || submitting || data?.disabled"
        >
            {{ 'features.establishment-switcher.add-dialog.submit' | transloco }}
        </button>
    </div>
</form>
